<template>
  <div class="col-span-6">
    <label for="field.label" class="block 2xl:text-sm sm:text-xl font-medium leading-5 text-gray-700">
      {{field.label}}
    </label>
    <div class="mt-1 relative 2xl:text-sm sm:text-xl">
      {{value}}
    </div>
  </div>
</template>
<script>
import { format, parseISO, intervalToDuration, addSeconds } from 'date-fns'
export default {
  name: 'legend-field',
  data() {
    return {
      value: '',
      dependentdata: {}
    }
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    params: {
      field: {
        type: Object
      }
    },
    formdata: {
      field: {
        type: Object,
        required: true,
      }
    },

  },

  created() {
    if (this.field.value === undefined) {
      this.checkDepends()
    } else {
      this.value = this.field.value
    }
  },

  watch: {
    formdata: {
      deep: true,
      handler: async function(newVal) {
        if (this.field.depends !== '' && this.field.depends !== undefined) {
          if ( typeof this.dependentdata[this.field.depends] === 'object'){
            if (this.field.depends in newVal) {
              if (JSON.stringify(this.dependentdata[this.field.depends]) !== JSON.stringify(newVal[this.field.depends])) {
                this.dependentdata[this.field.depends] = JSON.parse(JSON.stringify(newVal[this.field.depends]))
                await this.getValues()
              }
            } else if (this.field.depends in this.dependentdata && !(this.field.depends in newVal) ){
                delete this.dependentdata[this.field.depends]
                await this.getValues()
            } else {
              // this.value = undefined
            }
          } else {
            if (this.field.depends in newVal) {
              if (this.dependentdata[this.field.depends] !== newVal[this.field.depends]) {
                this.dependentdata[this.field.depends] = JSON.parse(JSON.stringify(newVal[this.field.depends]))
                await this.getValues()
              }
            }else{
              // this.value = undefined
            }
          }
        }
      }
    }
  },

  methods: {
    checkDepends() {
      if (this.field.depends === undefined || this.field.depends === "") {
        this.getValues()
      }
    },
    async getValues() {
      let config = {
        params: {
          legend: true,
          blueprint: this.$route.params.blueprint,
          id: this.$route.params.record,
          ...this.params,
          ...this.formdata,
          query: this.$route.query,
          formdata: this.formdata,
          params: this.params
        }
      }

      const response = await this.$http.get(this.field.uri, config)
      var payload = response.data[this.field.key]
      if (payload.renderer === 'datetime') {
        this.value = this.formatDateTime(payload.value)
      } else if (payload.renderer === 'date') {
        this.value = this.formatDate(payload.value)
      } else if (payload.renderer === 'timedelta') {
        this.value = this.formatDelta(payload.value)
      } else {
        this.value = payload.value
      }

      this.$parent.updateValue(this.field.key, this.value)
    },
    formatDateTime(val) {
      return format(parseISO(val), 'dd/MM/yy HH:mm:ss')
    },
    formatDate(val) {
      return format(parseISO(val), 'dd/MM/yyyy')
    },
    formatDelta(secs) {
      let duration = { days:0, hours:0, minutes:0, seconds:0 }
      if(secs){
        duration = intervalToDuration({
          start: new Date(),
          end: addSeconds(new Date(), secs)
        })
      }
      const zeros = data => data <= 9 ? `0${data}` : data

      if(duration.days == 1) {
        return `${duration.days} día, ${zeros(duration.hours)}:${zeros(duration.minutes)}:${zeros(duration.seconds)}`
      } else if(duration.days > 1){
        return `${duration.days} días, ${zeros(duration.hours)}:${zeros(duration.minutes)}:${zeros(duration.seconds)}`
      } else {
        return `${zeros(duration.hours)}:${zeros(duration.minutes)}:${zeros(duration.seconds)}`
      }
    },

  }
}
</script>
